<template>
	<v-expansion-panels accordion focusable v-model="isOpen">
		<faq-item
			v-for="(faq, index) in faqs"
			:key="index"
			:question="faq.question"
			:answer="faq.answer"
		></faq-item>
	</v-expansion-panels>
</template>

<script>
import FaqItem from './FaqItem';
import {ACTION_TYPES} from "../../../store/buyout/_action-types";
import {VUEX_BUYOUT} from "../../../store/buyout";
import {mapActions} from "vuex";
import { sortByOrder } from '../../../../js/buyout';

export default {
	name: 'Faqs',
	data() {
		return {
			faqs: [],
			isOpen: null
		}
	},
	props:{
		faqIdentifier:{
			type: String,
			default: 'base'
		}
	},
	async created() {
		if (!this.faqs.length) {
			await this.fetchData();
		}
	},
	components: {
		FaqItem
	},
	methods:{
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.LOAD_FAQS
		]),
		async fetchData() {
			this.faqs = sortByOrder(await this[ACTION_TYPES.LOAD_FAQS]({identifier: this.faqIdentifier}));
		}
	},
	watch: {
		"$i18n.locale"() {
			this.fetchData();
		}
	}
}
</script>
